import * as Yup from 'yup';
import { PASSWORD_STRENGHT } from "config";
import { staticData } from 'managers/staticDataManager';

export const initalLoginModel = {
    username: '',
    password: ''
};

export const loginValidationSchema = (state) => Yup.object().shape({
    username: Yup
        .string()
        .required(staticData.loadTerms(state, "VW_ISSUER_UsersValidation_login_username")),
    password: Yup
        .string()
        .required(staticData.loadTerms(state, "VW_ISSUER_UsersValidation_login_password")),
});

export const initialChangePasswordModel = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
};

export const changePasswordValidationSchema = (state) => Yup.object().shape({
    oldPassword: Yup.string()
        .required(staticData.loadTerms(state, "VW_ISSUER_UsersValidation_changePassword_oldPassword")),
    newPassword: Yup.string()
        .required(staticData.loadTerms(state, "VW_ISSUER_UsersValidation_changePassword_newPassword"))
        .matches(
            PASSWORD_STRENGHT,
            staticData.loadTerms(state, "VW_ISSUER_UsersValidation_changePassword_PASSWORD_STRENGHT")
            ),
    confirmPassword: Yup.string()
        .required(staticData.loadTerms(state, "VW_ISSUER_UsersValidation_changePassword_confirmPassword"))
        .oneOf([Yup.ref("newPassword"), null], staticData.loadTerms(state, "VW_ISSUER_UsersValidation_changePassword_confirmPassword_oneOf")),
});

export const initialForgotPasswordModal = {
    usefulData: ''
}

export const forgotPasswordValidationSchema = (state) => Yup.object().shape({
    usefulData: Yup.string()
        .required(staticData.loadTerms(state, "VW_ISSUER_UsersValidation_forgotPassword_usefulData"))
});

export const initialResetPasswordModal = {
    newPassword: "",
    confirmPassword: ""
}

export const resetPasswordVlidationSchema = (state) => Yup.object().shape({
    newPassword: Yup.string()
        .required(staticData.loadTerms(state, "VW_ISSUER_UsersValidation_resetPassword_newPassword"))
        .matches(
            PASSWORD_STRENGHT,
            staticData.loadTerms(state, "VW_ISSUER_UsersValidation_resetPassword_newPassword_PASSWORD_STRENGHT")
            ),
    confirmPassword: Yup.string()
        .required(staticData.loadTerms(state, "VW_ISSUER_UsersValidation_confirmPassword"))
        .oneOf([Yup.ref("newPassword"), null], staticData.loadTerms(state, "VW_ISSUER_UsersValidation_confirmPassword_oneOf")),
});

